
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb2b2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb2b2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hZ7sE", function(module, exports) {



const $d17debcb682d2f88$var$locals = {
    en: (parcelRequire("4207s")),
    ru: (parcelRequire("29xEZ")),
    es: (parcelRequire("4exhV"))
};
const $d17debcb682d2f88$var$processLang = Object.keys($d17debcb682d2f88$var$locals).indexOf("es") > -1 ? "es" : "en";
module.exports = $d17debcb682d2f88$var$locals[$d17debcb682d2f88$var$processLang];

});
parcelRegister("4207s", function(module, exports) {
module.exports = {
    languages: [
        "en",
        "ru",
        "es"
    ],
    currentLang: "en",
    domain: "veliky.net",
    loaderText: "https://veliky.net",
    indexTitle: "Eugene Veliky - Software Engineer",
    role: "Role",
    readMore: "Read more >>",
    close: "x Close",
    linkTo: "Link to",
    meta: {
        desc: "Eugene Veliky is a Senior Software Engineer with rich experience in building websites",
        keywords: "Front End, Full Stack, Vue, Wordpress, JavaScript, PHP, MySQL",
        title: "Eugene Veliky - Software Engineer",
        type: "website",
        image: "icon.png"
    },
    header: {
        professions: "Software Engineer",
        name: "Eugene Veliky",
        skillsOn: "> Show skills <",
        skillsOff: "x Hide x",
        links: {
            github: "https://github.com/veliky/",
            linkedin: "https://www.linkedin.com/in/eugenegreat/",
            share: ""
        }
    },
    experience: {
        title: "My job",
        desc: [
            "Making websites since 2008.",
            "From 2014 profesionally."
        ],
        companies: {
            huumun: {
                name: "Huumun",
                title: [
                    "Digital",
                    "Solutions",
                    "Provider"
                ],
                role: "Senior Software Engineer",
                content: "&emsp;Huumun is an established company from UK with a long history. Specializing in digital solutions in the life sciences sector. Among their clients are world-famous pharmaceutical companies. While working in the development team, I was able to complete a couple of interesting projects for Jazz Pharmaceutical and Pfizer."
            },
            smarteka: {
                name: "Smarteka.ru",
                title: [
                    "Social",
                    "Projects",
                    "Platform"
                ],
                role: "Lead Developer",
                content: "&emsp;Smarteka.com is a popular platform for social projects in many areas such as healthcare, culture, environment, education, entrepreneurship development and others. The functionality of the platform includes acceptance of application materials, moderation by industry experts, publication of approved projects and their results.<br>&emsp;As a lead developer, I developed new parts of the project, completed a full redesign of the project, and collaborated with other members of the development team."
            },
            socialbet: {
                name: "Social.bet",
                title: [
                    "Free",
                    "Contest",
                    "Platform"
                ],
                role: "Lead Developer",
                content: "&emsp;Social.bet was a startup whose purpose was competitions for sports fans. The project provided a wide range of gaming functionality, including odds for events from 10 different bookmakers, the ability to place bets for game currency and track statistics, different types of bets and types of competitions.<br>&emsp;As a Lead Developer, I took part in the development from initial stage of the project, throughout the entire project I was involved in the creation and development of functionality on the front-end and back-end as well.<br>&emsp;Unfortunately the project was closed during Covid cost cutting."
            },
            ignet: {
                name: "Ignet",
                title: [
                    "Web Agency",
                    "Ignet Solutions"
                ],
                role: "Software Developer",
                content: "&emsp;Ignet was a dynamic website development studio. We were specialized in complex projects implemented in WordPress. Some of our favorite tasks included input and output of large amounts of data, optimization of speed, responsive templates, and finally the creation of countless custom plugins and themes to work with a wide variety of APIs and types of content.<br>&emsp;This small company gave me a strong start in the form of experience working with different types of clients and projects in different areas. For almost 3 years, I have released more than 10 websites from scratch, and have taken part in the work of more than 30."
            }
        },
        pets: {
            title: "See pet projects >>",
            back: "<< Go back",
            list: {
                "embed-mixcloud-advanced": {
                    title: [
                        "Wordpress",
                        "Plugin"
                    ],
                    name: "Embed Mixcloud Advanced",
                    content: "&emsp;I have always been interested in listening to music and creating projects. This time it led to the successful experience of publishing the plugin in the official WordPress repository.<br>&emsp;The functionality of the project was specific to fans of the mixcloud.com music platform. The project was not popular and I decided to close it."
                },
                "iframe-new-tab": {
                    title: [
                        "Chrome",
                        "Extension"
                    ],
                    name: "Iframe New Tab",
                    content: "&emsp;I have long wanted to try to create a browser extension and when the right idea came up I did it. The functionality is not unique and primitive, but for me it was an experience of developing and publishing for a specific platform. The extension is still alive and can be installed even now!"
                },
                "spaze": {
                    title: [
                        "Mobile",
                        "website"
                    ],
                    name: "Spaze.ru",
                    content: "&emsp;This was my first project with a first-level domain. It was of a reference nature, dedicated to users of one mobile social network. He was not widely known but had a stable small audience. At the moment you can see fragments of sites in the web archive."
                },
                "sehack": {
                    title: [
                        "Mobile",
                        "website"
                    ],
                    name: "se-hack.wen.su",
                    content: "&emsp;I created my first website back in 2008 using a phone with a screen resolution of 128x128. And although it was created using a primitive website builder, I already went beyond the scope and learned how to use HTML and CSS. And it was available on the Internet! So my friends and I were competed to see whose site was cooler.<br>&emsp;Unfortunately, the hosting provider has closed and the site is no longer available."
                }
            }
        }
    },
    skills: [
        "JavaScript",
        "Vue",
        "Nuxt.js",
        "Webpack",
        "SASS",
        "SCSS",
        "D3.js",
        "SVG",
        "BEM",
        "CSS3",
        "Photoshop",
        "Figma",
        "HTML5",
        "PHP",
        "MySQL",
        "WordPress",
        "WooCommerce",
        "Gutenberg",
        "WP-CLI",
        "Composer",
        "OOP",
        "Linux",
        "Localization",
        "REST APIs",
        "Payment APIs",
        "CRON",
        "GitLab",
        "Jira",
        "PhpStorm",
        "Slack",
        "Trello",
        "Software Engineering",
        "Android Development",
        "xDebug"
    ],
    hobbies: {
        btn: "<< My hobbies",
        gallery: {
            title: "I like to take photos"
        },
        player: {
            title: "And enjoy listening to",
            subtitle: "Deep House music",
            prev: "Previous",
            play: "Play",
            next: "Next",
            toggle: "Expand or Minimize",
            info: {
                title: "Loading..."
            }
        }
    }
};

});

parcelRegister("29xEZ", function(module, exports) {
module.exports = {
    languages: [
        "en",
        "ru",
        "es"
    ],
    currentLang: "ru",
    domain: "veliky.net",
    loaderText: "https://ru.veliky.net",
    indexTitle: "\u0415\u0432\u0433\u0435\u043D\u0438\u0439 \u0412\u0435\u043B\u0438\u043A\u0438\u0439 - \u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A \u041F\u041E",
    role: "\u0420\u043E\u043B\u044C",
    readMore: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C >>",
    close: "x \u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    linkTo: "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430",
    meta: {
        desc: "\u0415\u0432\u0433\u0435\u043D\u0438\u0439 \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u044D\u0442\u043E \u0421\u0442\u0430\u0440\u0448\u0438\u0439 \u0418\u043D\u0436\u0438\u043D\u0435\u0440-\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0441\u0442 \u0441 \u0431\u043E\u0433\u0430\u0442\u044B\u043C \u043E\u043F\u044B\u0442\u043E\u043C \u0432 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0441\u0430\u0439\u0442\u043E\u0432",
        keywords: "Front End, Full Stack, Vue, Wordpress, JavaScript, PHP, MySQL",
        title: "\u0415\u0432\u0433\u0435\u043D\u0438\u0439 \u0412\u0435\u043B\u0438\u043A\u0438\u0439 - \u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A \u041F\u041E",
        type: "website",
        image: "icon.png"
    },
    header: {
        professions: "\u0418\u043D\u0436\u0435\u043D\u0435\u0440-\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0441\u0442",
        name: "\u0415\u0432\u0433\u0435\u043D \u0412\u0435\u043B\u0438\u043A\u0438\u0439",
        skillsOn: "> \u041C\u043E\u0438 \u043D\u0430\u0432\u044B\u043A\u0438 <",
        skillsOff: "x \u0421\u043A\u0440\u044B\u0442\u044C x",
        links: {
            github: "https://github.com/veliky/",
            linkedin: "https://www.linkedin.com/in/eugenegreat/",
            share: ""
        }
    },
    experience: {
        title: "\u041C\u043E\u044F \u0440\u0430\u0431\u043E\u0442\u0430",
        desc: [
            "\u0414\u0435\u043B\u0430\u044E \u0441\u0430\u0439\u0442\u044B \u0441 2008.",
            "\u0421 2014 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E."
        ],
        companies: {
            huumun: {
                name: "Huumun",
                title: [
                    "\u041F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A",
                    "\u0446\u0438\u0444\u0440\u043E\u0432\u044B\u0445",
                    "\u0440\u0435\u0448\u0435\u043D\u0438\u0439"
                ],
                role: "\u0421\u0442\u0430\u0440\u0448\u0438\u0439 \u0418\u043D\u0436\u0435\u043D\u0435\u0440-\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0441\u0442",
                content: "&emsp;Huumun \u044D\u0442\u043E \u0443\u0441\u0442\u043E\u044F\u0432\u0448\u0430\u044F\u0441\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0438\u0437 \u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u0438 \u0441 \u0434\u043B\u0438\u043D\u043D\u043E\u0439 \u0438\u0441\u0442\u043E\u0440\u0438\u0435\u0439. \u0421\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043D\u0430 \u0446\u0438\u0444\u0440\u043E\u0432\u044B\u0445 \u0440\u0435\u0448\u0435\u043D\u0438\u044F\u0445 \u0432 \u0441\u0444\u0435\u0440\u0435 \u0433\u0443\u043C\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u044B\u0445 \u043D\u0430\u0443\u043A. \u0421\u0440\u0435\u0434\u0438 \u0438\u0445 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u0441 \u043C\u0438\u0440\u043E\u0432\u044B\u043C \u0438\u043C\u0435\u043D\u0435\u043C. \u0412\u043E \u0432\u0440\u0435\u043C\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u0435 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438, \u043C\u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0434\u043B\u044F Jazz Pharmaceutical \u0438 Pfizer."
            },
            smarteka: {
                name: "Smarteka.ru",
                title: [
                    "\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430",
                    "\u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445",
                    "\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432"
                ],
                role: "\u0412\u0435\u0434\u0443\u0449\u0438\u0439 \u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A",
                content: "&emsp;Smarteka.com \u2014 \u044D\u0442\u043E \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0430\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0434\u043B\u044F \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0432\u043E \u043C\u043D\u043E\u0433\u0438\u0445 \u0441\u0444\u0435\u0440\u0430\u0445, \u0442\u0430\u043A\u0438\u0445 \u043A\u0430\u043A \u0437\u0434\u0440\u0430\u0432\u043E\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435, \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u0430, \u044D\u043A\u043E\u043B\u043E\u0433\u0438\u044F, \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435, \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u0435 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0438 \u0434\u0440\u0443\u0433\u0438\u0445. \u0424\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u043F\u0440\u0438\u0435\u043C \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0437\u0430\u044F\u0432\u043E\u043A, \u043C\u043E\u0434\u0435\u0440\u0430\u0446\u0438\u044E \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u0430\u043C\u0438 \u043E\u0442\u0440\u0430\u0441\u043B\u0438, \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u044E \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0438 \u0438\u0445 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432.<br>&emsp;\u0412 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0432\u0435\u0434\u0443\u0449\u0435\u0433\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430 \u044F \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0430\u043B \u043D\u043E\u0432\u044B\u0435 \u0447\u0430\u0441\u0442\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u043B \u043F\u043E\u043B\u043D\u0443\u044E \u0440\u0435\u0434\u0438\u0437\u0430\u0439\u043D \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0438 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u0447\u0430\u043B \u0441 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0447\u043B\u0435\u043D\u0430\u043C\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u0432."
            },
            socialbet: {
                name: "Social.bet",
                title: [
                    "\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430",
                    "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0445",
                    "\u043A\u043E\u043D\u043A\u0443\u0440\u0441\u043E\u0432"
                ],
                role: "\u0412\u0435\u0434\u0443\u0449\u0438\u0439 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A",
                content: "&emsp;Social.bet \u0431\u044B\u043B \u0441\u0442\u0430\u0440\u0442\u0430\u043F\u043E\u043C, \u0446\u0435\u043B\u044C\u044E \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u0431\u044B\u043B\u0438 \u0441\u043E\u0440\u0435\u0432\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043B\u044F \u043B\u044E\u0431\u0438\u0442\u0435\u043B\u0435\u0439 \u0441\u043F\u043E\u0440\u0442\u0430. \u0412 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D \u0448\u0438\u0440\u043E\u043A\u0438\u0439 \u0441\u043F\u0435\u043A\u0442\u0440 \u0438\u0433\u0440\u043E\u0432\u043E\u0433\u043E \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043A\u043E\u044D\u0444\u0444\u0438\u0446\u0438\u0435\u043D\u0442\u044B \u043D\u0430 \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u043E\u0442 10 \u0440\u0430\u0437\u043D\u044B\u0445 \u0431\u0443\u043A\u043C\u0435\u043A\u0435\u0440\u0441\u043A\u0438\u0445 \u043A\u043E\u043D\u0442\u043E\u0440, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0434\u0435\u043B\u0430\u0442\u044C \u0441\u0442\u0430\u0432\u043A\u0438 \u0437\u0430 \u0438\u0433\u0440\u043E\u0432\u0443\u044E \u0432\u0430\u043B\u044E\u0442\u0443 \u0438 \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443, \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u0432\u0438\u0434\u044B \u0441\u0442\u0430\u0432\u043E\u043A \u0438 \u0432\u0438\u0434\u044B \u0441\u043E\u0440\u0435\u0432\u043D\u043E\u0432\u0430\u043D\u0438\u0439.<br>&emsp;\u0412 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0432\u0435\u0434\u0443\u0449\u0435\u0433\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430 \u044F \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u043B \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u0441 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u0442\u0430\u0434\u0438\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u043D\u0430 \u043F\u0440\u043E\u0442\u044F\u0436\u0435\u043D\u0438\u0438 \u0432\u0441\u0435\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0437\u0430\u043D\u0438\u043C\u0430\u043B\u0441\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043C \u0438 \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u0435\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u0430 \u043A\u0430\u043A \u043D\u0430 \u0444\u0440\u043E\u043D\u0442\u0435\u043D\u0434\u0435, \u0442\u0430\u043A \u0438 \u043D\u0430 \u0431\u044D\u043A\u0435\u043D\u0434\u0435.<br>&emsp;\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043F\u0440\u043E\u0435\u043A\u0442 \u0431\u044B\u043B \u0437\u0430\u043A\u0440\u044B\u0442 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u044F \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u043F\u0440\u0438 Covid."
            },
            ignet: {
                name: "Ignet",
                title: [
                    "\u0412\u0435\u0431-\u0421\u0442\u0443\u0434\u0438\u044F",
                    "Ignet Solutions"
                ],
                role: "\u0418\u043D\u0436\u0438\u043D\u0435\u0440-\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0441\u0442",
                content: "&emsp;Ignet \u0431\u044B\u043B\u0430 \u0434\u0438\u043D\u0430\u043C\u0438\u0447\u043D\u043E\u0439 \u0441\u0442\u0443\u0434\u0438\u0435\u0439 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u043E\u0432. \u041C\u044B \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043B\u0438\u0441\u044C \u043D\u0430 \u0441\u043B\u043E\u0436\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445, \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043D\u0430 WordPress. \u041D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0438\u0437 \u043D\u0430\u0448\u0438\u0445 \u043B\u044E\u0431\u0438\u043C\u044B\u0445 \u0437\u0430\u0434\u0430\u0447 \u0432\u043A\u043B\u044E\u0447\u0430\u043B\u0438 \u0432\u0432\u043E\u0434 \u0438 \u0432\u044B\u0432\u043E\u0434 \u0431\u043E\u043B\u044C\u0448\u0438\u0445 \u043E\u0431\u044A\u0435\u043C\u043E\u0432 \u0434\u0430\u043D\u043D\u044B\u0445, \u043E\u043F\u0442\u0438\u043C\u0438\u0437\u0430\u0446\u0438\u044E \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u0438, \u0430\u0434\u0430\u043F\u0442\u0438\u0432\u043D\u044B\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B \u0438, \u043D\u0430\u043A\u043E\u043D\u0435\u0446, \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0431\u0435\u0441\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445 \u043F\u043B\u0430\u0433\u0438\u043D\u043E\u0432 \u0438 \u0442\u0435\u043C \u0434\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441 \u0448\u0438\u0440\u043E\u043A\u0438\u043C \u0441\u043F\u0435\u043A\u0442\u0440\u043E\u043C API \u0438 \u0442\u0438\u043F\u043E\u0432 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430.<br>&emsp;\u042D\u0442\u0430 \u043D\u0435\u0431\u043E\u043B\u044C\u0448\u0430\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0434\u0430\u043B\u0430 \u043C\u043D\u0435 \u0445\u043E\u0440\u043E\u0448\u0438\u0439 \u0441\u0442\u0430\u0440\u0442 \u0432 \u0432\u0438\u0434\u0435 \u043E\u043F\u044B\u0442\u0430 \u0440\u0430\u0431\u043E\u0442\u044B \u0441 \u0440\u0430\u0437\u043D\u044B\u043C\u0438 \u0442\u0438\u043F\u0430\u043C\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u043C\u0438 \u0432 \u0440\u0430\u0437\u043D\u044B\u0445 \u043E\u0431\u043B\u0430\u0441\u0442\u044F\u0445. \u0417\u0430 \u043F\u043E\u0447\u0442\u0438 3 \u0433\u043E\u0434\u0430 \u044F \u0432\u044B\u043F\u0443\u0441\u0442\u0438\u043B \u0441 \u043D\u0443\u043B\u044F \u0431\u043E\u043B\u0435\u0435 10 \u0441\u0430\u0439\u0442\u043E\u0432 \u0438 \u043F\u0440\u0438\u043D\u044F\u043B \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u0431\u043E\u043B\u0435\u0435 30."
            }
        },
        pets: {
            title: "\u0421\u0432\u043E\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u044B >>",
            back: "<< \u041D\u0430\u0437\u0430\u0434",
            list: {
                "embed-mixcloud-advanced": {
                    title: [
                        "Wordpress",
                        "\u041F\u043B\u0430\u0433\u0438\u043D"
                    ],
                    name: "Embed Mixcloud Advanced",
                    content: "&emsp;\u041C\u043D\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u0431\u044B\u043B\u043E \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u043E \u0441\u043B\u0443\u0448\u0430\u0442\u044C \u043C\u0443\u0437\u044B\u043A\u0443 \u0438 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442\u044B. \u041D\u0430 \u044D\u0442\u043E\u0442 \u0440\u0430\u0437 \u044D\u0442\u043E \u043F\u0440\u0438\u0432\u0435\u043B\u043E \u043A \u0443\u0441\u043F\u0435\u0448\u043D\u043E\u043C\u0443 \u043E\u043F\u044B\u0442\u0443 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043F\u043B\u0430\u0433\u0438\u043D\u0430 \u0432 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u043C \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u0438 WordPress.<br>&emsp;\u0424\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0431\u044B\u043B \u0441\u043F\u0435\u0446\u0438\u0444\u0438\u0447\u0435\u043D \u0434\u043B\u044F \u043F\u043E\u043A\u043B\u043E\u043D\u043D\u0438\u043A\u043E\u0432 \u043C\u0443\u0437\u044B\u043A\u0430\u043B\u044C\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B mixcloud.com. \u041F\u0440\u043E\u0435\u043A\u0442 \u043D\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043B\u0441\u044F \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u043E\u0441\u0442\u044C\u044E \u0438 \u044F \u0440\u0435\u0448\u0438\u043B \u0435\u0433\u043E \u0437\u0430\u043A\u0440\u044B\u0442\u044C."
                },
                "iframe-new-tab": {
                    title: [
                        "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435",
                        "\u0434\u043B\u044F Chrome"
                    ],
                    name: "Iframe New Tab",
                    content: "&emsp;\u0414\u0430\u0432\u043D\u043E \u0445\u043E\u0442\u0435\u043B \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 \u0438 \u043A\u043E\u0433\u0434\u0430 \u0432 \u0433\u043E\u043B\u043E\u0432\u0443 \u043F\u0440\u0438\u0448\u043B\u0430 \u043D\u0443\u0436\u043D\u0430\u044F \u0438\u0434\u0435\u044F, \u044F \u044D\u0442\u043E \u0441\u0434\u0435\u043B\u0430\u043B. \u0424\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B \u043D\u0435 \u0443\u043D\u0438\u043A\u0430\u043B\u0435\u043D \u0438 \u043D\u0435 \u043F\u0440\u0438\u043C\u0438\u0442\u0438\u0432\u0435\u043D, \u043D\u043E \u0434\u043B\u044F \u043C\u0435\u043D\u044F \u044D\u0442\u043E \u0431\u044B\u043B \u043E\u043F\u044B\u0442 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0438 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043F\u043E\u0434 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u0443\u044E \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0443. \u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u0432\u0441\u0435 \u0435\u0449\u0435 \u0436\u0438\u0432\u043E \u0438 \u0435\u0433\u043E \u043C\u043E\u0436\u043D\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0443\u0436\u0435 \u0441\u0435\u0439\u0447\u0430\u0441!"
                },
                "spaze": {
                    title: [
                        "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439",
                        "\u0441\u0430\u0439\u0442"
                    ],
                    name: "Spaze.ru",
                    content: "&emsp;\u042D\u0442\u043E \u0431\u044B\u043B \u043C\u043E\u0439 \u043F\u0435\u0440\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442 \u0441 \u0434\u043E\u043C\u0435\u043D\u043E\u043C \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F. \u041E\u043D\u043E \u043D\u043E\u0441\u0438\u043B\u043E \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u044B\u0439 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440, \u043F\u043E\u0441\u0432\u044F\u0449\u0435\u043D\u043D\u043E\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u043E\u0434\u043D\u043E\u0439 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0439 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u0435\u0442\u0438. \u041E\u043D \u043D\u0435 \u0431\u044B\u043B \u0448\u0438\u0440\u043E\u043A\u043E \u0438\u0437\u0432\u0435\u0441\u0442\u0435\u043D, \u043D\u043E \u0438\u043C\u0435\u043B \u0441\u0442\u0430\u0431\u0438\u043B\u044C\u043D\u0443\u044E \u043D\u0435\u0431\u043E\u043B\u044C\u0448\u0443\u044E \u0430\u0443\u0434\u0438\u0442\u043E\u0440\u0438\u044E. \u041D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u044B \u0441\u0430\u0439\u0442\u043E\u0432 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0432 \u0432\u0435\u0431-\u0430\u0440\u0445\u0438\u0432\u0435."
                },
                "sehack": {
                    title: [
                        "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439",
                        "\u0441\u0430\u0439\u0442"
                    ],
                    name: "se-hack.wen.su",
                    content: "&emsp;\u0421\u0432\u043E\u0439 \u043F\u0435\u0440\u0432\u044B\u0439 \u0441\u0430\u0439\u0442 \u044F \u0441\u043E\u0437\u0434\u0430\u043B \u0435\u0449\u0435 \u0432 2008 \u0433\u043E\u0434\u0443 \u043D\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435 \u0441 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0435\u043C \u044D\u043A\u0440\u0430\u043D\u0430 128x128. \u0418 \u0445\u043E\u0442\u044F \u043E\u043D \u0431\u044B\u043B \u0441\u043E\u0437\u0434\u0430\u043D \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043F\u0440\u0438\u043C\u0438\u0442\u0438\u0432\u043D\u043E\u0433\u043E \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u0430 \u0441\u0430\u0439\u0442\u043E\u0432, \u044F \u0443\u0436\u0435 \u0432\u044B\u0445\u043E\u0434\u0438\u043B \u0437\u0430 \u0440\u0430\u043C\u043A\u0438 \u0438 \u043D\u0430\u0443\u0447\u0438\u043B\u0441\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C HTML \u0438 CSS. \u0418 \u044D\u0442\u043E \u0431\u044B\u043B\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u043D\u0430 \u0432\u0435\u0441\u044C \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442! \u0422\u0430\u043A \u0447\u0442\u043E \u043C\u044B \u0441 \u0434\u0440\u0443\u0437\u044C\u044F\u043C\u0438 \u0441\u043E\u0440\u0435\u0432\u043D\u043E\u0432\u0430\u043B\u0438\u0441\u044C \u0447\u0435\u0439 \u0441\u0430\u0439\u0442 \u043A\u0440\u0443\u0447\u0435.<br>&emsp;\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0445\u043E\u0441\u0442\u0438\u043D\u0433-\u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 \u0437\u0430\u043A\u0440\u044B\u043B\u0441\u044F \u0438 \u0441\u0430\u0439\u0442 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D."
                }
            }
        }
    },
    skills: [
        "JavaScript",
        "Vue",
        "Nuxt.js",
        "Webpack",
        "SASS",
        "SCSS",
        "D3.js",
        "SVG",
        "BEM",
        "CSS3",
        "Photoshop",
        "Figma",
        "HTML5",
        "PHP",
        "MySQL",
        "WordPress",
        "WooCommerce",
        "Gutenberg",
        "WP-CLI",
        "Composer",
        "OOP",
        "Linux",
        "Localization",
        "REST APIs",
        "Payment APIs",
        "CRON",
        "GitLab",
        "Jira",
        "PhpStorm",
        "Slack",
        "Trello",
        "Software Engineering",
        "Android Development",
        "xDebug"
    ],
    hobbies: {
        btn: "<< \u041C\u043E\u0438 \u0445\u043E\u0431\u0431\u0438",
        gallery: {
            title: "\u042F \u043B\u044E\u0431\u043B\u044E \u0434\u0435\u043B\u0430\u0442\u044C \u0444\u043E\u0442\u043E"
        },
        player: {
            title: "\u0410 \u0442\u0430\u043A \u0436\u0435 \u0441\u043B\u0443\u0448\u0430\u0442\u044C",
            subtitle: "Deep House \u0441\u0435\u0442\u044B",
            prev: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439",
            play: "\u0418\u0433\u0440\u0430\u0442\u044C",
            next: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439",
            toggle: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0438\u043B\u0438 \u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
            info: {
                title: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
            }
        }
    }
};

});

parcelRegister("4exhV", function(module, exports) {
module.exports = {
    languages: [
        "en",
        "ru",
        "es"
    ],
    currentLang: "es",
    domain: "veliky.net",
    loaderText: "https://es.veliky.net",
    indexTitle: "Eugenio Veliky - Desarrollador de Software",
    role: "Funci\xf3n",
    readMore: "Abrir >>",
    close: "x Cerrar",
    linkTo: "Enlace a",
    meta: {
        desc: "Eugenio Veliky es un Ingeniero de Software Senior con amplia experiencia en la creaci\xf3n de sitios web",
        keywords: "Front End, Full Stack, Vue, Wordpress, JavaScript, PHP, MySQL",
        title: "Eugenio Veliky - Desarrollador de Software",
        type: "website",
        image: "icon.png"
    },
    header: {
        professions: "Desarrollador de Software",
        name: "Eugenio Veliky",
        skillsOn: "> Mis habilidades <",
        skillsOff: "x Ocultar x",
        links: {
            github: "https://github.com/veliky/",
            linkedin: "https://www.linkedin.com/in/eugenegreat/",
            share: ""
        }
    },
    experience: {
        title: "Mi trabajo",
        desc: [
            "Hago p\xe1ginas web desde 2008.",
            "Desde 2014 profesionalmente."
        ],
        companies: {
            huumun: {
                name: "Huumun",
                title: [
                    "Proveedor",
                    "de Soluciones",
                    "Digitales"
                ],
                role: "Ingeniero de Software S\xe9nior",
                content: "&emsp;Huumun es una empresa establecida del Reino Unido con una larga trayectoria. Especializada en soluciones digitales en el sector de las ciencias de la vida. Entre sus clientes se encuentran empresas farmac\xe9uticas de fama mundial. Mientras trabajaba en el equipo de desarrollo, pude completar un par de proyectos interesantes para Jazz Pharmaceutical y Pfizer."
            },
            smarteka: {
                name: "Smarteka.ru",
                title: [
                    "Plataforma",
                    "para Proyectos",
                    "Sociales"
                ],
                role: "Desarrollador Principal",
                content: "&emsp;Smarteka.com es una plataforma popular para proyectos sociales en muchas \xe1reas como salud, cultura, medio ambiente, educaci\xf3n, desarrollo empresarial y otras. La funcionalidad de la plataforma incluye la aceptaci\xf3n de los materiales de solicitud, la moderaci\xf3n por parte de expertos de la industria, la publicaci\xf3n de los proyectos aprobados y sus resultados.<br>&emsp;Como Desarrollador Principal, desarroll\xe9 nuevas partes del proyecto, complet\xe9 un redise\xf1o completo del proyecto y colabor\xe9 con otros miembros del equipo de desarrollo."
            },
            socialbet: {
                name: "Social.bet",
                title: [
                    "Plataforma",
                    "para Concursos",
                    "Gratuitas"
                ],
                role: "Desarrollador Principal",
                content: "&emsp;Social.bet era una startup cuyo objetivo eran las competiciones para aficionados al deporte. El proyecto proporcion\xf3 una amplia gama de funcionalidades de juego, incluidas probabilidades para eventos de 10 casas de apuestas diferentes, la capacidad de realizar apuestas por la moneda del juego y realizar un seguimiento de las estad\xedsticas, diferentes tipos de apuestas y tipos de competiciones.<br>&emsp;Como Desarrollador Principal, particip\xe9 en el desarrollo desde la etapa inicial del proyecto, durante todo el proyecto estuve involucrado en la creaci\xf3n y desarrollo de funcionalidades tanto en el front-end como en el back-end.<br>&emsp;Desafortunadamente, el proyecto se cerr\xf3 durante la reducci\xf3n de costos de Covid."
            },
            ignet: {
                name: "Ignet",
                title: [
                    "Estudio de",
                    "Desarrollo Web",
                    "Ignet Solutions"
                ],
                role: "Desarrollador de Software",
                content: "&emsp;Ignet era un estudio de desarrollo de sitios web din\xe1mico. Nos especializamos en proyectos complejos implementados en WordPress. Algunas de nuestras tareas favoritas inclu\xedan la entrada y salida de grandes cantidades de datos, optimizaci\xf3n de la velocidad, plantillas responsivas y, finalmente, la creaci\xf3n de innumerables complementos y temas personalizados para trabajar con una amplia variedad de API y tipos de contenido.<br>&emsp;Esta peque\xf1a empresa me dio un fuerte comienzo en forma de experiencia trabajando con diferentes tipos de clientes y proyectos en diferentes \xe1reas. Durante casi 3 a\xf1os, he lanzado m\xe1s de 10 sitios web desde cero y he participado en el trabajo de m\xe1s de 30."
            }
        },
        pets: {
            title: "Proyectos propios >>",
            back: "<< Atr\xe1s",
            list: {
                "embed-mixcloud-advanced": {
                    title: [
                        "Wordpress",
                        "Plugin"
                    ],
                    name: "Embed Mixcloud Advanced",
                    content: "&emsp;Siempre me ha interesado escuchar m\xfasica y crear proyectos. Esta vez condujo a la exitosa experiencia de publicar el complemento en el repositorio oficial de WordPress.<br>&emsp;La funcionalidad del proyecto era espec\xedfica para los fan\xe1ticos de la plataforma de m\xfasica mixcloud.com. El proyecto no fue popular y decid\xed cerrarlo."
                },
                "iframe-new-tab": {
                    title: [
                        "Chrome",
                        "Extension"
                    ],
                    name: "Iframe New Tab",
                    content: "&emsp;Hace tiempo que quer\xeda intentar crear una extensi\xf3n para el navegador y cuando surgi\xf3 la idea correcta lo hice. La funcionalidad no es \xfanica ni primitiva, pero para m\xed fue una experiencia de desarrollo y publicaci\xf3n para una plataforma espec\xedfica. \xa1La extensi\xf3n todav\xeda est\xe1 viva y se puede instalar incluso ahora!"
                },
                "spaze": {
                    title: [
                        "Sitio",
                        "movil"
                    ],
                    name: "Spaze.ru",
                    content: "&emsp;Este fue mi primer proyecto con un dominio de primer nivel. Era de car\xe1cter de referencia, dedicado a los usuarios de una red social m\xf3vil. No era muy conocido pero ten\xeda una peque\xf1a audiencia estable. Actualmente puedes ver fragmentos de sitios en el archivo web."
                },
                "sehack": {
                    title: [
                        "Sitio",
                        "movil"
                    ],
                    name: "se-hack.wen.su",
                    content: "&emsp;Cre\xe9 mi primer sitio web en 2008 usando un tel\xe9fono con una resoluci\xf3n de pantalla de 128x128. Y aunque fue creado usando un creador de sitios web primitivo, ya fui m\xe1s all\xe1 y aprend\xed a usar HTML y CSS. \xa1Y estaba disponible en Internet! As\xed que mis amigos y yo competimos para ver cu\xe1l sitio era m\xe1s genial.<br>&emsp;Desafortunadamente, el proveedor de alojamiento cerr\xf3 y el sitio ya no est\xe1 disponible."
                }
            }
        }
    },
    skills: [
        "JavaScript",
        "Vue",
        "Nuxt.js",
        "Webpack",
        "SASS",
        "SCSS",
        "D3.js",
        "SVG",
        "BEM",
        "CSS3",
        "Photoshop",
        "Figma",
        "HTML5",
        "PHP",
        "MySQL",
        "WordPress",
        "WooCommerce",
        "Gutenberg",
        "WP-CLI",
        "Composer",
        "OOP",
        "Linux",
        "Localization",
        "REST APIs",
        "Payment APIs",
        "CRON",
        "GitLab",
        "Jira",
        "PhpStorm",
        "Slack",
        "Trello",
        "Software Engineering",
        "Android Development",
        "xDebug"
    ],
    hobbies: {
        btn: "<< Mis Aficiones",
        gallery: {
            title: "Me gusta tomar fotos"
        },
        player: {
            title: "Y escuchar",
            subtitle: "Deep House m\xfasica",
            prev: "Previo",
            play: "Jugar",
            next: "Proximo",
            toggle: "Revelar o Minimizar",
            info: {
                title: "Descarga..."
            }
        }
    }
};

});


parcelRegister("LMLC2", function(module, exports) {
module.exports = {
    /**
   * @param {string} className
   * @return {(function(*): void)|*}
   */ toggleBodyClass: (className)=>(e)=>{
            e.preventDefault();
            if (document.body.className.indexOf(className) > -1) document.body.classList.remove(className);
            else document.body.classList.add(className);
        }
};

});



(()=>{
    const locals = (parcelRequire("hZ7sE"));
    const { toggleBodyClass: toggleBodyClass } = (parcelRequire("LMLC2"));
    const experienceHashList = [
        "huumun",
        "smarteka",
        "socialbet",
        "ignet",
        "iframe-new-tab",
        "embed-mixcloud-advanced",
        "spaze",
        "sehack"
    ];
    const petsHashList = [
        "iframe-new-tab",
        "embed-mixcloud-advanced",
        "spaze",
        "sehack"
    ];
    const gridClass = "evp-exp__grid";
    const petsGridClass = "evp-exp__grid_pets";
    const itemClass = "evp-exp__col";
    const hiddenClass = "evp-exp_hidden";
    /**
   * @return undefined
   */ const init = ()=>{
        // Handle header skills button
        const skillBtnOn = document.querySelector(".evp-profile-links__skills_on a");
        const skillBtnOff = document.querySelector(".evp-profile-links__skills_off a");
        skillBtnOn.addEventListener("click", (e)=>{
            toggleBodyClass("evp-t-skills")(e);
            setTimeout(()=>skillBtnOff.focus(), 200);
        });
        skillBtnOff.addEventListener("click", (e)=>{
            toggleBodyClass("evp-t-skills")(e);
            setTimeout(()=>skillBtnOn.focus(), 200);
        });
        // Share API
        const [title, text] = locals.indexTitle.split(" - ");
        const shareData = {
            title: title,
            text: text,
            url: locals.loaderText
        };
        if (navigator.canShare && navigator.canShare(shareData)) {
            const shareLink = document.querySelector(".evp-profile-links__ext-item_share");
            shareLink.style.display = "block";
            shareLink.addEventListener("click", async (e)=>{
                e.preventDefault();
                try {
                    await navigator.share(shareData);
                } catch (err) {
                    console.error(err);
                }
            });
        }
        // Navigate page with initial hash
        hashToClass(document.location.hash);
        // Navigate by links
        const boxLinks = document.querySelectorAll(".evp-exp a");
        for(let i = 0; i < boxLinks.length; i++)boxLinks[i].addEventListener("click", (e)=>{
            const hash = hashToClass(boxLinks[i].getAttribute("href"));
            // Focus [ Close ] on open
            const closeBtn = document.querySelector(".evp-exp__content_" + hash + " .evp-exp__content-close");
            if (closeBtn) {
                setTimeout(()=>{
                    closeBtn.focus();
                }, 200);
                // Focus BOX on close
                closeBtn.addEventListener("click", ()=>{
                    setTimeout(()=>{
                        boxLinks[i].focus();
                    }, 200);
                });
            }
        });
        // Client-side Go back feature
        navigation.addEventListener("navigate", navigateBack);
    };
    /**
   * @param url
   * @return {string}
   */ const getHash = (url)=>(url || "").split("#")[1];
    /**
   * @param {String} hash
   *
   * @return {String}
   */ const hashToClass = (hash)=>{
        hash = hash ? hash.replace("#", "") : "";
        document.body.className = document.body.className.replace(/\bevp-h-\S+/ig, "");
        if (hash.length > 0) {
            document.body.classList.add("evp-h-" + hash);
            hideExperienceItemsExcept(hash);
            displayExperienceItems(hash);
        } else displayExperienceItems();
        return hash;
    };
    /**
   * @param {{}} event
   */ const navigateBack = (event)=>{
        if ("traverse" === event.navigationType) {
            const hash = event.destination.url.split("#")[1];
            hashToClass(hash);
        }
    };
    /**
   * @param hash
   */ const hideExperienceItemsExcept = (hash)=>{
        if (experienceHashList.indexOf(hash) > -1) {
            let boxListToHide = petsHashList.indexOf(hash) > -1 ? document.querySelectorAll(`.${petsGridClass} .${itemClass}:not(.${itemClass}_${hash})`) : document.querySelectorAll(`.${gridClass}:not(.${petsGridClass}) .${itemClass}:not(.${itemClass}_${hash})`);
            for(let i = 0; i < boxListToHide.length; i++)boxListToHide[i].classList.add(hiddenClass);
        }
    };
    /**
   * @param {string} hash
   *
   * @return undefined
   */ const displayExperienceItems = (hash = "")=>{
        if (hash.length > 0 && experienceHashList.indexOf(hash) > -1) document.querySelector(`.${itemClass}_${hash}`).classList.remove(hiddenClass);
        else for(let i = 0; i < experienceHashList.length; i++)document.querySelector(`.${itemClass}_` + experienceHashList[i]).classList.remove(hiddenClass);
    };
    // Init
    // document.addEventListener('DOMContentLoaded', init)
    init();
})();


//# sourceMappingURL=index.b2e48dfd.js.map
